<app-form-box>
	<form [formGroup]="form" (ngSubmit)="onFormSubmit()">
		<app-form-label>Login</app-form-label>

		<br />

		<app-text-field
			[fg]="form"
			formGroupOrControlName="username"
			label="ID / E-Mail"
			placeholder="ID number or E-Mail"
			autocomplete="username"
		></app-text-field>

		<app-password-field
			[fg]="form"
			formGroupOrControlName="password"
			label="Password"
			autocomplete="current-password"
		></app-password-field>

		<app-form-submit-button [disabled]="!form.valid || loading()" [loading]="loading()">Login</app-form-submit-button>
	</form>

	@if (isCleverSsoAllowed()) {
		<div class="clever-login">
			<app-clever-login-button></app-clever-login-button>
		</div>
	}

	<br />

	<div class="footer-links">
		<app-form-link (click)="onForgotPassword()">Forgot Password</app-form-link>
		@if (isSelfRosteringAllowed() && !isCleverSsoAllowed()) {
			<app-form-link (click)="onCreateAccount()">Create Account</app-form-link>
		}
	</div>
</app-form-box>